import vtkCellArray from './CellArray';
import vtkDataArray from './DataArray';
import vtkEndian from './Endian';
import vtkLookupTable from './LookupTable';
import vtkMath from './Math';
import vtkPoints from './Points';
import vtkScalarsToColors from './ScalarsToColors';
import vtkStringArray from './StringArray';
import vtkURLExtract from './URLExtract';
import vtkVariantArray from './VariantArray';

export default {
  vtkCellArray,
  vtkDataArray,
  vtkEndian,
  vtkLookupTable,
  vtkMath,
  vtkPoints,
  vtkScalarsToColors,
  vtkStringArray,
  vtkURLExtract,
  vtkVariantArray,
};
